export const FEATURE_TYPE = {
	baseStation: 'baseStation',
	baseStationCircle: 'baseStationCircle',
	baseStationLabel: 'baseStationLabel',
	baseStationSubnetworkCircles: 'baseStationSubnetworkCircles',
	getterActive: 'getterActive',
	getterFailed: 'getterFailed',
	vrsStation: 'vrsStation',
	vrsStationCircle: 'vrsStationCircle',
	getterLink: 'getterLink',
	gridpoint: 'gridpoint',
	geoFencingCircle: 'geoFencingCircle',
	baselineLinkSelfCircle: 'baselineLinkSelfCircle',
	baselineLinkLine: 'baselineLinkLine',
	baselineLinkArrowHead: 'baselineLinkArrowHead',
	profileGeoFencingCenter: 'profileGeoFencingCenter',
	profileGeoFencingCircle: 'profileGeoFencingCircle',
	roverHistoryCurrent: 'roverHistoryCurrent',
	roverHistoryFragment: 'roverHistoryFragment',
	roverHistoryFragmentBreakEnd: 'roverHistoryFragmentBreakEnd',
	roverHistoryFragmentNormalEnd: 'roverHistoryFragmentNormalEnd',
	roverHistoryFragmentLastEnd: 'roverHistoryFragmentLastEnd',
	coverageContour: 'coverageContour',
	qualityRectangle: 'qualityRectangle',
	anchorPoint: 'anchorPoint',
	cnetConstructorGridpoint: 'cnetConstructorGridpoint',
	cnetConstructorOtherGridpoint: 'cnetConstructorOtherGridpoint',
} as const;


export type FeatureType = (typeof FEATURE_TYPE)[keyof typeof FEATURE_TYPE];


export const FEATURE_TYPE_VALUES = Object.values(FEATURE_TYPE) as readonly FeatureType[];


export const MAP_MODE = {
	main: 'main',
	subNetworks: 'subNetworks',
	coverage: 'coverage',
	gnss: 'gnss',
	gnssPerGridpoint: 'gnssPerGridpoint',
	snr: 'snr',
	multipath: 'multipath',
	residuals: 'residuals',
	paasStddev: 'paasStddev',
	baselines: 'baselines',
	cnetConstructor: 'cnetConstructor',
	roversHistory: 'roversHistory',
} as const;


export type MapMode = (typeof MAP_MODE)[keyof typeof MAP_MODE];
